/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'down-arrow': {
    width: 16,
    height: 16,
    viewBox: '2 2 12 12',
    data: '<path pid="0" d="M8 2c.196 0 .36.142.394.328L8.4 2.4v10.234l4.117-4.117a.4.4 0 01.612.51l-.046.056-4.8 4.8-.034.03-.05.034-.074.033-.054.014L8 14l-.043-.002-.058-.011-.065-.023-.062-.035-.055-.046-4.8-4.8a.4.4 0 01.51-.612l.056.046L7.6 12.634V2.4c0-.22.18-.4.4-.4z" _fill="#000" fill-rule="evenodd"/>'
  }
})
